import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { useDispatch } from "react-redux";
import {
  getClinicInformation,
  updateClinicLogo,
} from "../../actions/profileAction";
import { ERROR } from "../../constants/types/alertType";
import { getUserDetail } from "../../utils/helper";
const ImageCropper = ({ closePopup, getuploadFile, clinicId, setValue }) => {
  const [file, setFile] = useState(null);
  const [originalFile, setOriginalFile] = useState(null);
  const dispatch = useDispatch();
  const [crop, setCrop] = useState({
    x: 0,
    y: 0,
    width: 200,
    height: 60,
  });
  const [image, setImage] = useState(null);
  const handleFileChange = (e) => {
    let file = e.target.files[0];
    if (file.size > 5000000) {
      dispatch({
        type: ERROR,
        payload: "File too Big, please select a smaller file",
      });
    } else {
      setFile(URL.createObjectURL(file));
      setOriginalFile(file);
    }
  };

  const uploadFile = (newfile) => {
    debugger;
    if (getuploadFile) {
      getuploadFile(newfile);
      closePopup();
      return;
    }

    let formData = new FormData();

    formData.append("clinic_id", clinicId);
    formData.append("token", getUserDetail()?.token);
    formData.append("clinic_logo", newfile);
    dispatch(
      updateClinicLogo(formData, () => {
        dispatch(getClinicInformation());
        setValue(Math.random());
      })
    );
  };

  const getCroppedImg = async (image, crop, fileName) => {
    try {
      const canvas = document.createElement("canvas");
      const scaleX = image.naturalWidth / image.width;
      const scaleY = image.naturalHeight / image.height;
      canvas.width = crop.width;
      canvas.height = crop.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width,
        crop.height
      );

      return new Promise((resolve, reject) => {
        canvas.toBlob(
          (blob) => {
            blob.name = fileName;
            resolve(blob);
          },
          "image/png",
          1
        );
      });
    } catch (e) {
      console.log("crop the image");
    }
  };
  const getImage = async () => {
    if (!file) {
      dispatch({
        type: ERROR,
        payload: "Please select a image first",
      });
      return;
    }
    const croppedImg = await getCroppedImg(image, crop, `${clinicId}_logo.png`);
    uploadFile(
      new File([croppedImg], `${clinicId}_logo.png`, { type: "image/png" })
    );
    closePopup();
  };

  return (
    <Modal size="xl" show={true} backdrop="static">
      <Modal.Header>
        <div className="modal-title">
          <h5 className="profile-title">Upload Clinic Logo</h5>
          <div className="close-btn">
            <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex flex-column">
          <input
            id="file"
            name="file"
            type="file"
            accept="image/*"
            onChange={handleFileChange}
          />
          <div className="crop-view">
            {file && (
              <ReactCrop
                style={{ width: "100%", height: "80%" }}
                src={file}
                crop={crop}
                onImageLoaded={setImage}
                onChange={(newCrop) => setCrop(newCrop)}
              />
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="submit-section">
          <button className="btn-orange mr-4" onClick={getImage}>
            Upload
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ImageCropper;
